import { FaFacebook, FaInstagram } from 'react-icons/fa';

export const baseServerUrl =
  'https://root2code-mulla-express-server.onrender.com';

export const lessonsData_url =
  'https://root2code-mulla-express-server.onrender.com/lessen';

export const links = [
  {
    id: 1,
    text: 'home',
    url: '/',
  },
  {
    id: 3,
    text: 'lessen',
    url: '/lessen',
  },
  {
    id: 4,
    text: 'activiteiten',
    url: '/activiteiten',
  },
  {
    id: 5,
    text: 'contact',
    url: '/contact',
  },
  {
    id: 2,
    text: 'about',
    url: '/about',
  },
];

export const social = [
  {
    id: 1,
    url: 'https://www.facebook.com/profile.php?id=100089738624503',
    icon: <FaFacebook />,
  },
  {
    id: 2,
    url: 'http://instagram.com/versweyveldgitte?igshid=ZDdkNTZiNTM=',
    icon: <FaInstagram />,
  },
];

export const services = [
  {
    id: 1,
    name: 'FitKlas',
    location: {
      name: 'Sporthal Vrije basisschool Wezel',
      address: 'Keiheuvelstraat 7a 2400 Mol',
    },
    description: 'FitKlas omschrijving',
    image: {
      url: '',
      alt: '',
    },
  },
  {
    id: 2,
    name: 'Family Acro Yoga',
    location: {
      name: 'Zaaltje vzw LouTieJu',
      address: 'Ongelberg 146 2490 Balen',
    },
    description: 'Family Acro Yoga omschrijving',
    image: {
      url: '',
      alt: '',
    },
  },
  {
    id: 3,
    name: 'CrossFit 4 Kids',
    location: {
      name: 'CrossFit Blue Fenix',
      address: 'Gompelbaan 209 2400 Mol',
    },
    description: 'CrossFit 4 kids omschrijving',
    image: {
      url: '',
      alt: '',
    },
  },
];

export const upcommingFKLessons = [
  {
    id: 1,
    day: 'maandag',
    date: '2023-03-13',
    time: '19:00:00',
    duration: '1 u',
    location: {
      name: 'Sporthal Vrije basisschool Wezel',
      address: 'Keiheuvelstraat 7a 2400 Mol',
    },
    upcomming: true,
  },
  {
    id: 2,
    day: 'maandag',
    date: '2023-03-20',
    time: '19:00:00',
    duration: '1 u',
    location: {
      name: 'Sporthal Vrije basisschool Wezel',
      address: 'Keiheuvelstraat 7a 2400 Mol',
    },
    upcomming: true,
  },
  {
    id: 3,
    day: 'maandag',
    date: '2023-03-27',
    time: '19:00:00',
    duration: '1 u',
    location: {
      name: 'Sporthal Vrije basisschool Wezel',
      address: 'Keiheuvelstraat 7a 2400 Mol',
    },
    upcomming: true,
  },
  {
    id: 4,
    day: 'maandag',
    date: '2023-04-17',
    time: '19:00:00',
    duration: '1 u',
    location: {
      name: 'Sporthal Vrije basisschool Wezel',
      address: 'Keiheuvelstraat 7a 2400 Mol',
    },
    upcomming: true,
  },
];

export const upcommingFamAcroLessons = [
  {
    id: 5,
    day: 'zondag',
    date: '2023-03-12',
    time: '10:00:00',
    duration: '45 minuten',
    age: 'Kleuters 2,5 - 6',
    location: {
      name: 'Zaaltje vzw LouTieJu',
      address: 'Ongelberg 146 2490 Balen',
    },
    upcomming: true,
  },
  {
    id: 6,
    day: 'zondag',
    date: '2023-12-03',
    time: '11:30:00',
    duration: '45 minuten',
    age: '7+',
    location: {
      name: 'Zaaltje vzw LouTieJu',
      address: 'Ongelberg 146 2490 Balen',
    },
    upcomming: true,
  },
  {
    id: 7,
    day: 'zondag',
    date: '2023-03-26',
    time: '10:00:00',
    duration: '45 minuten',
    age: 'Kleuters 2,5 - 6',
    location: {
      name: 'Zaaltje vzw LouTieJu',
      address: 'Ongelberg 146 2490 Balen',
    },
    upcomming: true,
  },
  {
    id: 8,
    day: 'zondag',
    date: '2023-03-26',
    time: '11:30:00',
    duration: '45 minutes',
    age: '7+',
    location: {
      name: 'Zaaltje vzw LouTieJu',
      address: 'Ongelberg 146 2490 Balen',
    },
    upcomming: false,
  },
  {
    id: 9,
    day: 'zondag',
    date: '2023-04-23',
    time: '10:00:00',
    duration: '45 minutes',
    age: 'Kleuters 2,5 - 6',
    location: {
      name: 'Zaaltje vzw LouTieJu',
      address: 'Ongelberg 146 2490 Balen',
    },
    upcomming: false,
  },
  {
    id: 10,
    day: 'zondag',
    date: '2023-04-23',
    time: '11:30:00',
    duration: '45 minutes',
    age: '7+',
    location: {
      name: 'Zaaltje vzw LouTieJu',
      address: 'Ongelberg 146 2490 Balen',
    },
    upcomming: false,
  },
  {
    id: 11,
    day: 'zondag',
    date: '2023-05-07',
    time: '10:00:00',
    duration: '45 minutes',
    age: 'Kleuters 2,5 - 6',
    location: {
      name: 'Zaaltje vzw LouTieJu',
      address: 'Ongelberg 146 2490 Balen',
    },
    upcomming: false,
  },
  {
    id: 12,
    day: 'zondag',
    date: '2023-05-07',
    time: '11:30:00',
    duration: '45 minutes',
    age: '7+',
    location: {
      name: 'Zaaltje vzw LouTieJu',
      address: 'Ongelberg 146 2490 Balen',
    },
    upcomming: false,
  },
  {
    id: 13,
    day: 'zondag',
    date: '2023-06-04',
    time: '10:00:00',
    duration: '45 minutes',
    age: 'Kleuters 2,5 - 6',
    location: {
      name: 'Zaaltje vzw LouTieJu',
      address: 'Ongelberg 146 2490 Balen',
    },
    upcomming: false,
  },
  {
    id: 14,
    day: 'zondag',
    date: '2023-06-04',
    time: '11:30:00',
    duration: '45 minutes',
    age: '7+',
    location: {
      name: 'Zaaltje vzw LouTieJu',
      address: 'Ongelberg 146 2490 Balen',
    },
    upcomming: false,
  },
  {
    id: 15,
    day: 'zondag',
    date: '2023-06-18',
    time: '10:00:00',
    duration: '45 minutes',
    age: 'Kleuters 2,5 - 6',
    location: {
      name: 'Zaaltje vzw LouTieJu',
      address: 'Ongelberg 146 2490 Balen',
    },
    upcomming: false,
  },
  {
    id: 16,
    day: 'zondag',
    date: '2023-06-18',
    time: '11:30:00',
    duration: '45 minutes',
    age: '7+',
    location: {
      name: 'Zaaltje vzw LouTieJu',
      address: 'Ongelberg 146 2490 Balen',
    },
    upcomming: false,
  },
];

export const upcommingXFitClassLessons = [
  {
    id: 17,
    day: 'zaterdag',
    date: '2023-03-04',
    time: '12:30:00',
    duration: '1 u',
    age: '4 - 7 jaar',
    location: {
      name: 'CrossFit Blue Fenix',
      address: 'Gompelbaan 209 2400 Mol',
    },
    upcomming: true,
  },
  {
    id: 18,
    day: 'zaterdag',
    date: '2023-03-04',
    time: '13:45:00',
    duration: '1 u',
    age: '8+ jaar',
    location: {
      name: 'CrossFit Blue Fenix',
      address: 'Gompelbaan 209 2400 Mol',
    },
    upcomming: true,
  },
  {
    id: 19,
    day: 'zaterdag',
    date: '2023-03-11',
    time: '12:30:00',
    duration: '1 u',
    age: '4 - 7 jaar',
    location: {
      name: 'CrossFit Blue Fenix',
      address: 'Gompelbaan 209 2400 Mol',
    },
    upcomming: false,
  },
  {
    id: 20,
    day: 'zaterdag',
    date: '2023-03-11',
    time: '13:45:00',
    duration: '1 u',
    age: '8+ jaar',
    location: {
      name: 'CrossFit Blue Fenix',
      address: 'Gompelbaan 209 2400 Mol',
    },
    upcomming: false,
  },
  {
    id: 21,
    day: 'zaterdag',
    date: '2023-03-18',
    time: '12:30:00',
    duration: '1 u',
    age: '4 - 7 jaar',
    location: {
      name: 'CrossFit Blue Fenix',
      address: 'Gompelbaan 209 2400 Mol',
    },
    upcomming: false,
  },
  {
    id: 22,
    day: 'zaterdag',
    date: '2023-03-18',
    time: '13:45:00',
    duration: '1 u',
    age: '8+ jaar',
    location: {
      name: 'CrossFit Blue Fenix',
      address: 'Gompelbaan 209 2400 Mol',
    },
    upcomming: false,
  },
];
